import React from "react";
import { ShareButton } from "../../atoms/form/button/share";
import { FaRedditAlien } from "react-icons/fa";
import styled from "styled-components";
import { trackClipSocialShare, trackCreatorCardShare } from "./utils";

const StyledShare = styled(FaRedditAlien)`
  color: #f8fcfd;
`;

export default function RedditShare({ link, clip, card, ...props }) {
  return (
    <>
      <ShareButton
        title="Share to Reddit"
        justifyContent={"center"}
        alignItems="center"
        flex={true}
        display="flex"
        href={`https://www.reddit.com/submit?url=${link}${
          props.title ? `&title=${props.title}` : ``
        }`}
        target="_blank"
        onClick={() => {
          if (clip) {
            trackClipSocialShare({
              platform: "Reddit",
              isMontage: clip.isMontage,
              clip,
            });
          } else if (card) {
            trackCreatorCardShare(card);
          }
        }}
        {...props}
      >
        <StyledShare size={24}></StyledShare>
        {props.children}
      </ShareButton>
    </>
  );
}
